/**
 * PostHog Analytics Service for Dis Maman! PWA
 */
import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_ohezkPvHpyxGrQf9EaTTDHd6WnNoj6t8BGfDD3FfdTLT';
const POSTHOG_HOST = 'https://eu.i.posthog.com';

let initialized = false;

export function initPostHog() {
  if (initialized) return;
  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: false,
    });
    initialized = true;
  } catch (e) {
    console.error('PostHog init error:', e);
  }
}

export function identifyUser(userId, properties = {}) {
  if (!initialized) return;
  posthog.identify(userId, properties);
}

export function trackEvent(event, properties = {}) {
  if (!initialized) return;
  posthog.capture(event, properties);
}

export function resetUser() {
  if (!initialized) return;
  posthog.reset();
}

// Event name constants
export const EVENTS = {
  USER_SIGNED_UP: 'user_signed_up',
  QUESTION_ASKED: 'question_asked',
  QUESTION_ANSWERED: 'question_answered',
  QUIZ_STARTED: 'quiz_started',
  QUIZ_COMPLETED: 'quiz_completed',
  STORY_GENERATED: 'story_generated',
  PREMIUM_SCREEN_VIEWED: 'premium_screen_viewed',
  PREMIUM_CTA_CLICKED: 'premium_cta_clicked',
  SUBSCRIPTION_STARTED: 'subscription_started',
  STREAK_MILESTONE: 'streak_milestone',
  BADGE_UNLOCKED: 'badge_unlocked',
  STARS_EARNED: 'stars_earned',
  STARS_SPENT: 'stars_spent',
};
